import { Button, ButtonProps, Flex, Link, LinkProps } from '@rover/kibble/core';
import { ButtonVariants } from '@rover/kibble/core/Button';
import { LinkVariant } from '@rover/kibble/core/Link/Link.common';
import { useBrightHorizonsActionHandler } from '@rover/pages/src/bright-horizons/hooks/useBrightHorizonsActionHandler';
import { ButtonBh } from '@rover/rsdk/src/apiClient/latest';

import { getBhCtaButtonIconProps } from './BhCtaButton.utils';

type BaseProps = {
  cta?: ButtonBh | null;
  renderCtaTitle?: (cta: ButtonBh) => JSX.Element;
};

type LinkPropsWithOptionalHref = Omit<LinkProps, 'href' | 'children'> &
  Partial<Pick<LinkProps, 'href'>>;

export type Props = BaseProps &
  (
    | ({
        asLink: true;
      } & LinkPropsWithOptionalHref)
    | ({
        asLink?: false;
      } & ButtonProps)
  );

export const BhCtaButton = (props: Props): JSX.Element | null => {
  const { cta, asLink, renderCtaTitle } = props;
  const actionProps = useBrightHorizonsActionHandler({
    action: cta?.action,
  });

  if (!cta) return null;

  const iconProps = getBhCtaButtonIconProps(cta);

  const ctaTitle = renderCtaTitle?.(cta) ?? cta.title;

  // Map onClick to onPress for Link component
  const linkActionProps =
    asLink && actionProps.onClick
      ? { ...actionProps, onPress: actionProps.onClick, onClick: undefined }
      : actionProps;

  return (
    <Flex>
      {asLink ? (
        <Link
          underline
          variant={cta.linkType as LinkVariant}
          {...iconProps}
          {...(linkActionProps as LinkProps)}
          {...props}
        >
          {ctaTitle}
        </Link>
      ) : (
        <Button
          variant={cta.buttonType as ButtonVariants}
          {...iconProps}
          {...actionProps}
          {...props}
        >
          {ctaTitle}
        </Button>
      )}
    </Flex>
  );
};
